<template>
  <div>
    <!-- Page Title -->
    <page-title icon="fa fa-solid fa-clipboard" main="Cadastro" sub="Painel meta de compra" :help="true" titleHelp="Página responsavel pelo cadastro das metas de compras dos fornecedores"
    content="Após selecionar um anosafra, basta alterar o volume da meta do produto desejado e salvar suas alterações.">
    </page-title>

    <supplier-goal-filter
      @search="search"
    />
    <supplier-goal-list
      :filters="filters"
    />
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Popover,
  Tooltip,
} from "element-ui";

import PageTitle from "@/layouts/PageTitle";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import SupplierGoalFilter from "@/views/SupplierPurchaseGoal/components/SupplierPurchaseGoalFilters.vue";
import SupplierGoalList from "@/views/SupplierPurchaseGoal/components/SupplierPurchaseGoalList.vue";

export default {
  components: {
    PageTitle,
    Multiselect,
    Collapse,
    CollapseItem,
    SupplierGoalFilter,
    SupplierGoalList,
    [Popover.name]: Popover,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tooltip.name]: Tooltip,
    VueListPicker,
  },
  name: "SupplierPurchaseGoals",
  data() {
    return {
      filters: {},
    }
  },
  async mounted() {
  },
  methods: {
    search(value) {
      this.filters = value;
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="scss">
  #accordion {
    .card {
      border-radius: 8px;
    }
  }
</style>
